export default "assets/images/icon_link-f6a1b2ed.png";